<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import { getTeamsByTeamIds, getMembersByTeamId, addTeam } from '@/api/FirebaseTeamWrapper.js'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
import { countCharacters, sortArraybyUpdatedAt } from '@/api/Utilities.js'

export default {
  components: {modalWindow},
  data () {
    return {
      userId: '',
      userData: undefined,
      teamsMap: new Map(),
      teamsData: [],
      isReloading: false,
      enableExternalUserWindow: false,
      enableMakeTeamWindow: false,
      alertMakeTeamMsg: '',
      makingTeamName: '',
      makingTeamNameLength: 0,
      path: '',
      isHover: false,
      hoverType: ''
    }
  },
  async created () {
    await this.init()
  },
  watch: {
    makingTeamName: function (val) {
      this.makingTeamNameLength = countCharacters(this.makingTeamName)
    },
    $route (to, from) {
      // ハイライト用にpathを保持
      this.path = to.path
    }
  },
  methods: {
    async init () {
      this.userId = await getMyUserId()
      this.userData = await getMyUserData()
      const teamsOrigin = await getTeamsByTeamIds(this.userData.teams)
      const teams = sortArraybyUpdatedAt(teamsOrigin)
      this.teamsMap = new Map()
      for (const team of teams) {
        const members = await getMembersByTeamId(team.id)
        const teamData = {name: team.teamName, isShow: true, members: members}
        this.teamsMap.set(team.id, teamData)
      }
      this.teamsData = Array.from(this.teamsMap)
    },
    pullDown (teamId, teamData) {
      const team = {name: teamData.name, isShow: !teamData.isShow, members: teamData.members}
      this.teamsMap.set(teamId, team)
      this.teamsData = Array.from(this.teamsMap)
    },
    async reload () {
      this.isReloading = true
      await this.init()
      this.isReloading = false
    },
    cancelTeamBar () {
      this.$emit('cancelTeamBar', false)
    },
    clickMakeTeam () {
      this.enableMakeTeamWindow = true
      this.alertMakeTeamMsg = ''
      this.makingTeamName = ''
    },
    cancelMakeTeam () {
      this.enableMakeTeamWindow = false
      this.alertMakeTeamMsg = ''
      this.makingTeamName = ''
    },
    async postTeam () {
      // console.log('postTeam')
      this.alertMakeTeamMsg = ''
      const teamName = this.makingTeamName
      if (!teamName) {
        this.alertMakeTeamMsg = '文字を入力してください'
        return
      }
      const msg = teamName
      // console.log('length: ' + msg.length)
      if (msg.length > 20) {
        this.alertMakeTeamMsg = '20文字を超えてます'
        return
      }
      try {
        // teamを作る
        const teamRef = await addTeam(this.makingTeamName)
        this.enableMakeTeamWindow = false
        this.alertMakeTeamMsg = ''
        this.makingTeamName = ''
        Router.push('/editteam/' + teamRef.id)
      } catch (err) {
        this.alertMakeTeamMsg = 'failed!'
        console.error(err)
      }
    },
    mouseOver (index) {
      this.isHover = true
      this.hoverType = index
    },
    mouseLeave () {
      this.isHover = false
      this.hoverType = ''
    }
  }
}
</script>
<style scoped>
.team {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  border-top: 1.0px solid rgba(220, 220, 220, 0.5);
}

.members {
  overflow-wrap: break-word;
  margin-left: 1.4rem;
}
.member {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  padding-left: 0.4rem;
}
.is-pullup{
  color: #000;
  cursor: pointer;
  cursor: hand;
}
.is-pulldown {
  color: #000;
  cursor: pointer;
  cursor: hand;
}
.add-hover:hover {
  background-color: #dbdbdb;
}
.markdown {
  background-color: #dbdbdb;
  border-radius: 0.2rem;
}
.is-size-7-1 {
  font-size: .85rem!important;
}
.is-size-8 {
  font-size: 0.55rem !important;
}
.toast {
  margin-top: 0.5rem;
  background-color: #000;
  padding: 0.2rem 0.8rem;
  border-radius: 0.5rem;
  position: absolute;
  z-index: 5;
}
.bd-categories .columns .column {
  overflow: unset;
}
</style>
<template>
  <div class="teambar">
    <nav class="bd-docs-nav">
      <nav class="bd-categories has-text-left">
        <!-- Treeの更新 -->
        <div class="columns is-multiline is-mobile is-marginless">
          <div class="column is-paddingless is-half">
            <div class="buttons">
              <button class="button is-small" @click="reload()" v-if="!isReloading">
                <span class="icon is-small">
                  <i class="fa-solid fa-redo-alt"></i>
                </span>
                <span>更新</span>
              </button>
              <button class="button is-small is-link is-loading" v-else>Loading</button>
            </div>
          </div>
          <div class="column is-paddingless is-half">
            <div class="buttons has-addons is-right">
              <button class="delete" @click="cancelTeamBar()">
              </button>
            </div>
          </div>
        </div>
        <!-- チームの表示 -->
        <div class="team has-text-weight-bold is-size-7-1" v-for="[teamId, team] in teamsData" :key="teamId">
          <div class="columns is-multiline is-mobile is-marginless is-pullup" v-bind:class="{'is-pulldown' : team.isShow}">
            <div @click="pullDown(teamId, team)" class="column is-paddingless is-10">
              <span class="icon" v-if="!team.isShow"><i class="fa-solid fa-caret-right"></i></span>
              <span class="icon" v-else><i class="fa-solid fa-caret-down"></i></span>
              {{team.name}}
              <br>
            </div>
            <div class="column is-paddingless is-2 has-text-right"
            v-on:mouseover="mouseOver(teamId)" v-on:mouseleave="mouseLeave()">
              <router-link class="router has-text-dark" v-bind:to="{ path: '/editteam/' + teamId }" >
                <span class="icon add-hover"><i class="fa-solid fa-ellipsis-v"></i></span>
              </router-link>
              <div class="toast has-text-white is-dark is-size-8" v-if="isHover && hoverType===teamId">
                <p>チームを管理</p>
              </div>
            </div>
          </div>
          <!-- メンバーの表示 -->
          <div class="members is-size-8" v-for="member in team.members" :key="member.userId" v-show="team.isShow">
            <div class="member markdown" v-if="path === '/profile/' + member.userId">
              <router-link v-bind:to="{ path: '/profile/' + member.userId}" >
                {{member.name}}
              </router-link>
            </div>
            <div class="member" v-else>
              <router-link v-bind:to="{ path: '/profile/' + member.userId}" >
                {{member.name}}
              </router-link>
            </div>
          </div>
        </div>
      </nav>
    </nav>
    <!--新規チーム追加-->
    <div class="add-team">
      <div class="columns is-multiline is-mobile is-marginless">
        <div class="column is-paddingless is-8  has-text-left">
          <span class="icon"><i class="fa-solid fa-user-plus"></i></span>
          <span class="text has-text-weight-bold is-size-7">新規チーム作成</span>
        </div>
        <div class="column is-paddingless is-4 has-text-right" @click="clickMakeTeam()"
        v-on:mouseover="mouseOver('team')" v-on:mouseleave="mouseLeave()">
          <span class="icon add-hover"><i class="fa-solid fa-plus"></i></span>
          <div class="toast has-text-white is-dark is-size-8" v-if="isHover && hoverType==='team'">
            <p>新規チームを作る</p>
          </div>
        </div>
      </div>
    </div>
    <div class="maketeam-modal-window">
      <modalWindow @close="cancelMakeTeam()" v-if="enableMakeTeamWindow">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="cancelMakeTeam()"></button>
          </div>
        </template>
        <div class='maketeam'>
          <p>チーム名を記入</p>
          <div class="field">
            <div class="control">
              <input v-if="makingTeamNameLength<=20" class="input" placeholder="チーム名" v-model="makingTeamName">
              <input v-else class="input is-danger" placeholder="20文字OVER" v-model="makingTeamName">
            </div>
          </div>
          <div class="q-bar">
            <div class="columns is-mobile is-marginless">
              <div class="column is-three-quarters">
                <div class="add-paddingleft">
                  <progress class="progress is-gray is-small" :value="makingTeamNameLength" max="20"></progress>
                </div>
              </div>
              <div class="column is-size-7">残り{{20-makingTeamNameLength}}</div>
            </div>
          </div>
        </div>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button" @click="cancelMakeTeam()">キャンセル</button>
            &nbsp;
            &nbsp;
            &nbsp;
            <button class="button is-link" v-if="makingTeamName !=='' && makingTeamNameLength <= 20" @click.once="postTeam()">作成</button>
            <button class="button is-link" v-else @click="postTeam()">作成</button>
          </div>
          <p class="help is-danger has-text-centered">{{alertMakeTeamMsg}}</p>
        </template>
      </modalWindow>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/globals/teambar/TeamBar.vue